import { differenceInMinutes } from 'date-fns';
import { RoomTicket, TicketStatus } from 'src/app/models/ticket.model';
import { convertTimestamp } from 'src/app/utility/time';

export function formatWorkerTaskDuration(totalMinutes: number) {
  const minutes = Math.max(0, Math.floor(totalMinutes));
  const hoursPart = Math.floor(minutes / 60);
  const minutesPart = minutes % 60;
  if (hoursPart > 0 && minutesPart > 0) {
    return `${hoursPart} h ${minutesPart} min`;
  }
  if (hoursPart > 0) {
    return `${hoursPart} h`;
  }
  return `${minutesPart} min`;
}

export function getWorkerTaskElapsedMinutes(ticket: RoomTicket, now: Date) {
  const history = (ticket.history ?? [])
    .map((entry) => ({ status: entry.status, timestamp: convertTimestamp(entry.timestamp) }))
    .filter((entry) => entry.timestamp instanceof Date)
    .sort((left, right) => left.timestamp.getTime() - right.timestamp.getTime());

  let elapsed = 0;
  let activeStart: Date | null = null;
  history.forEach((entry) => {
    if (entry.status === TicketStatus.inProgress) {
      activeStart = entry.timestamp;
      return;
    }
    if (activeStart != null) {
      elapsed += Math.max(0, differenceInMinutes(entry.timestamp, activeStart));
      activeStart = null;
    }
  });

  if (activeStart != null && ticket.status === TicketStatus.inProgress) {
    elapsed += Math.max(0, differenceInMinutes(now, activeStart));
  }
  return elapsed;
}

export function getWorkerTaskEstimateMinutes(ticket: RoomTicket) {
  const hours = typeof ticket.hours === 'number' ? ticket.hours : Number(ticket.hours);
  return Number.isFinite(hours) && hours > 0 ? Math.round(hours * 60) : null;
}

export function getWorkerTaskProgressPercent(elapsedMinutes: number, estimateMinutes: number | null) {
  if (!estimateMinutes || estimateMinutes <= 0) {
    return null;
  }
  return Math.min(100, Math.round((elapsedMinutes / estimateMinutes) * 100));
}
